import dayjs from "dayjs";

import { useTranslation } from "@/core/i18n";
import { Icon } from "atoms/icon/Icon";
import ChevronRight from "atoms/icon/icons/chevron_right_small.svg";
import RepeatMD from "atoms/icon/icons/RepeatCash.svg";
import { formatCurrency } from "toolbox/Money";

export interface HistoryListEntryProps {
  id: string;
  title: string;
  badge?: string | null;
  subtitle?: string | null | undefined;
  date: string | null | undefined;
  repeatCash?: number | null;
  refunded?: boolean;
  onClick?: () => void;
}

export const HistoryListEntry = (props: HistoryListEntryProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={`flex items-center justify-between bg-white py-4 pl-6 pr-4 ${
        props.onClick ? "cursor-pointer" : ""
      }`}
      key={props.id}
      onClick={props.onClick}
    >
      <div className="mr-4 flex flex-1 flex-col gap-1 text-left">
        <div className="flex items-center gap-2 text-body1 capitalize text-primary">
          {props.title}
          {props.badge && (
            <span className="inline-block rounded-full bg-gray-200 px-2 py-0.5 text-[10px] font-semibold uppercase leading-tight text-gray-600">
              {props.badge}
            </span>
          )}
        </div>
        {props.subtitle && !props.repeatCash && (
          <div className="text-body1 capitalize text-secondary">
            {props.refunded ? (
              <>
                <span className="line-through">{props.subtitle}</span>
                <span> ({t("historyListEntry.refunded")})</span>
              </>
            ) : (
              props.subtitle
            )}
          </div>
        )}
        {props.repeatCash && (
          <div className="flex items-center gap-1 font-sans text-body1 text-secondary">
            {t("historyListEntry.bankedFor")}
            <Icon svg={RepeatMD} color="primaryText" size="xsmall" />
            {formatCurrency(props.repeatCash)}
          </div>
        )}
      </div>
      <div className="mr-3 text-body1 text-secondary">{dayjs(props.date).format("L")}</div>
      {props.onClick && <Icon svg={ChevronRight} color="brandColor" size="small" />}
    </div>
  );
};
